/* Replace full file in C:\TravelAdvisorApp\client\src\components\TravelAssociatesModal.js */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './DetailComponents.css';

const TravelAssociatesModal = ({ onSave, onClose }) => {
  const [newAssociate, setNewAssociate] = useState({ name: '', relationship: 'Select...', dob: null });
  const modalRef = useRef(null);

  const handleClickOutside = useCallback((event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      onClose();
    }
  }, [onClose]);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [handleClickOutside]);

  const handleSave = () => {
    if (newAssociate.name && newAssociate.relationship) {
      onSave(newAssociate);
    }
  };

  const relationships = ['Spouse', 'Partner', 'Son', 'Daughter', 'Father', 'Mother', 'Brother', 'Sister', 'Friend', 'Other'];

  return (
    <div className="modal-overlay">
      <div className="modal edit-modal" ref={modalRef}>
        <h3>Add Travel Associate</h3>
        <div className="edit-modal-form">
          <div className="edit-modal-field">
            <label className="edit-modal-label">Name:</label>
            <input
              className="edit-modal-input"
              placeholder="Enter name"
              value={newAssociate.name}
              onChange={e => setNewAssociate({ ...newAssociate, name: e.target.value })}
            />
          </div>
          <div className="edit-modal-field">
            <label className="edit-modal-label">Relationship:</label>
            <select
              className="edit-modal-input"
              value={newAssociate.relationship}
              onChange={e => setNewAssociate({ ...newAssociate, relationship: e.target.value })}
            >
              {relationships.map(rel => (
                <option key={rel} value={rel}>{rel}</option>
              ))}
            </select>
          </div>
          <div className="edit-modal-field">
            <label className="edit-modal-label">Date of Birth:</label>
            <DatePicker
              selected={newAssociate.dob}
              onChange={date => setNewAssociate({ ...newAssociate, dob: date })}
              dateFormat="MMMM d, yyyy"
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              className="edit-modal-input"
            />
          </div>
        </div>
        <div className="modal-actions">
          <button className="modal-action-button" onClick={onClose}>Cancel</button>
          <button className="modal-action-button" onClick={handleSave}>Save</button>
        </div>
      </div>
    </div>
  );
};

export default TravelAssociatesModal;